<div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <div [hidden]="!hasRouteAccess(routes.SECURE.ACCOUNT.BULK)" class="form-group">
        <div [hidden]="isResultListEmpty()" class="margin-top-bottom">
          <h3>
            <i class="fa fa-info-circle"></i> No bulk request to pay transactions found. </h3>
          </div>
          <app-search-view>
            <app-bulk-payment-search #app [autoRefresh]="true" filters></app-bulk-payment-search>
            <table class="table table-hover table-responsive-md table-wrap-sm" grid>
              <thead>
                <tr>
                  <th #batchNumber
                    (click)="applySorting(batchNumber.id, app)"
                    class="sort-field text-center"
                    id="batchNumber"
                    scope="col">
                    Batch Number
                    <em class="{{isDesc(batchNumber.id) ? 'fa fa-sort-desc': isAsc(batchNumber.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #batchName
                    (click)="applySorting(batchName.id, app)"
                    class="sort-field text-center"
                    id="batchName"
                    scope="col">
                    Batch Name
                    <em class="{{isDesc(batchName.id) ? 'fa fa-sort-desc': isAsc(batchName.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #dateTimeCreated
                    (click)="applySorting(dateTimeCreated.id, app)"
                    class="sort-field text-center"
                    id="dateTimeCreated"
                    scope="col">
                    Date Created
                    <em class="{{ isDesc(dateTimeCreated.id) ? 'fa fa-sort-desc': isAsc(dateTimeCreated.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #totalRequests
                    (click)="applySorting(totalRequests.id, app)"
                    class="sort-field text-center"
                    id="totalRequests"
                    scope="col">
                    Total Requests
                    <em class="{{ isDesc(totalRequests.id) ? 'fa fa-sort-desc': isAsc(totalRequests.id) ? 'fa fa-sort-asc':'fa fa-sort'}}"></em>
                  </th>
                  <th #batchStatus class="text-center" id="batchStatus" scope="col">
                    Status
                  </th>
                  <th class="text-center" id="batchNotificationStatus" scope="col">
                    Notification Status <i class="pi pi-question-circle tooltip-icon"
                  pTooltip="A generaliezed status for all request to pays in the batch"></i>
                </th>

                <th class="text-center" id="resendBatchNotifications" scope="col">
                  Resend Notifications <i class="pi pi-question-circle tooltip-icon"
                pTooltip="Resend all failed/not sent notifications."></i>
              </th>

              <th class="text-center" scope="col">
                Batch File <i class="pi pi-question-circle tooltip-icon"
              pTooltip="{{getBulkFileTooltipText()}}"></i>
            </th>
            <th class="text-center" scope="col">
              Cancel <i class="pi pi-question-circle tooltip-icon"
            pTooltip="Cancel all outstanding request-to-pay (RTP) links in the batch."></i>
          </th>
          <th class="text-center" scope="col">
                                Upload Errors <i class="pi pi-question-circle tooltip-icon" pTooltip="Download a list of request-to-pay (RTP) that failed during the upload.
                                    The file is in CSV format."></i>
        </th>
      </tr>
    </thead>
    <tbody class="table-hover text-nowrap">
      @for (batch of content; track batch) {
        <tr class="cursor-pointer  active-color">
          <td (click)="view(batch)">
            <span class="p-column-title">Batch Number</span>
            {{ batch.batchNumber }}
          </td>
          <td (click)="view(batch)">
            <span class="p-column-title">Batch Name</span>
            {{ batch.batchName }}
          </td>
          <td (click)="view(batch)">
            <span class="p-column-title">Date Created</span>
            {{ batch.dateTimeCreated | amFromUtc | amLocal | amDateFormat: 'YYYY-MM-DD HH:mm:ss' }}
          </td>
          <td (click)="view(batch)">
            <span class="p-column-title">Total Requests</span>
            {{ batch.totalRequests }}
          </td>
          <td (click)="view(batch)">
            <span class="p-column-title">Status</span>
            {{ getBatchState(batch.accountBatchState) }}
          </td>
          <td (click)="view(batch)">
            <span class="p-column-title">Notification Status</span>
            {{ batch.notificationStatus | formatNotificationStatus }}
          </td>
          <hr/>
          <td>
            <div [hidden]="batch.notificationStatus == 'SENT' || batch.notificationStatus == 'SENDING'"
              class="text-center">
              <div class="disabled-tooltip-wrapper"
                [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot send notifications.' : null">
                <div (click)="openResendBatchNotificationsDialog(batch)"
                  [class.grey-circle-style]="isGuestAdminUser()"
                  class="circle-style">
                  <i class="fa fa-send fa-lg"></i>
                </div>
              </div>
              <span class="p-column-title ">Resend</span>
            </div>
          </td>
          <td>
            <div class="text-center">
              <div class="disabled-tooltip-wrapper"
                [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot download account bulk files.' : null">
                <div (click)="getAccountBulkFile(batch)"
                  [class.grey-circle-style]="isGuestAdminUser()"
                  class="circle-style">
                  <i class="fa fa-download fa-lg"></i>
                </div>
              </div>
              <span class="p-column-title ">Download</span>
            </div>
          </td>
          <td>
            <div class="text-center">
              <div class="disabled-tooltip-wrapper"
                [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot cancel batches.' : null">
                <div (click)="cancel(batch)"
                  [class.grey-circle-style]="isGuestAdminUser()"
                  class="circle-style">
                  <i class="fa fa-trash fa-lg"></i>
                </div>
              </div>
              <span class="p-column-title ">Cancel</span>
            </div>
          </td>
          <td>
            <div [hidden]="!batch.hasUploadErrors" class="text-center">
              <div class="disabled-tooltip-wrapper"
                [pTooltip]="isGuestAdminUser() ? 'Guest accounts cannot download batch errors.' : null">
                <div (click)="downloadUploadErrors(batch)"
                  [class.grey-circle-style]="isGuestAdminUser()"
                  class="circle-style">
                  <i class="pi pi-arrow-circle-down pi-lg"></i>
                </div>
              </div>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</app-search-view>
</div>
</div>
</div>
</div>

<p-dialog [(visible)]="showResendBatchNotificationsDialog"
  [closable]="false"
  [modal]="true"
  [showHeader]="false"
  [style]="{width: '450px'}"
  styleClass="confirm-dialog">
  <div class="m-1">
    <h6 class="font-weight-bold d-flex flex-column text-center" style="font-size: 1.75rem !important;">
      <span>Resend Notifications for</span>
      <span>Batch Number: {{ selectedAccountBatch?.batchNumber }}</span>
      <br>
      </h6>
      <div class="m-1 form-group">
        <label for="sendEmailInput"> Send Email Notifications</label>
        <div class="form-inline">
          <p-toggleswitch [(ngModel)]="sendEmail"
            [ngModelOptions]="{standalone: true}"
          id="sendEmailInput"></p-toggleswitch>
          <p class="margin-toggle">{{ isSendEmailText() }}</p>
        </div>
        @if (hasInsufficientEmailCredits) {
          <small class="text-danger">You have insufficient email credits.</small>
        }
      </div>
      <div class="m-1 form-group">
        <label for="sendSMSInput"> Send SMS Notifications</label>
        <div class="form-inline align-content-center">
          <p-toggleswitch [(ngModel)]="sendSMS"
            [disabled]="hasInsufficientSMSCredits"
            [ngModelOptions]="{standalone: true}"
          id="sendSMSInput"></p-toggleswitch>
          <p class="margin-toggle">{{ isSendSMSText() }}</p>
        </div>
        @if (hasInsufficientSMSCredits) {
          <small class="text-danger">You have insufficient SMS credits.</small>
        }
      </div>
      <div class="row modal-buttons">
        <button (click)="closeResendBatchNotificationsDialog()" class="btn-light btn-margin-top-bottom">
          Cancel <i class="fa fa-close"></i>
        </button>
        <button (click)="resendBatchNotifications()"
          [disabled]="!(sendEmail || sendSMS)"
          class="navy-btn btn-margin-top-bottom">
          Send <i class="fa fa-send fa-lg"></i>
        </button>
      </div>
    </div>
  </p-dialog>